<template>
  <q-list bordered class="q-pa-md q-pa-lg-lg bg-white more-rounded-borders" v-if="service_location">
    <q-expansion-item v-model="expanded" header-class="text-bold" header-style="font-size: 20px"
                      icon="place" label="Service Address">
      <q-card>

        <q-card-section>
          <div>
            <div class="flex q-gutter-x-sm text-100">
              <div class="text-bold">{{ service_location?.label }}</div>
            </div>
            <div class="flex q-gutter-x-sm text-100">
              <div class="text-blue-grey-4">{{ service_location?.esiid }}</div>
            </div>
          </div>

          <div class="text-right">
            <q-btn v-if="show_edit" color="primary" no-caps class="text-bold bg-blue-1 text-primary" label="Change Service Address"
                   flat to="/order/service_location" padding="8px"></q-btn>
          </div>
        </q-card-section>

      </q-card>

    </q-expansion-item>
  </q-list>
</template>

<script>
import { ref } from "vue";

export default {
  name: "ServiceLocationCard",
  props: {
    service_location: {
      type: Object,
      required: true
    },
    show_edit: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const expanded = ref(true);
    return {
      expanded
    }
  }
}
</script>

<style scoped>

</style>
